(function () {
  const STORAGE_KEY = 'florame_funnel_state_v2';
  const TTL_MS = 7 * 24 * 60 * 60 * 1000;

  function storageFrom(options = {}) {
    return options.storage || window.localStorage;
  }

  function nowFrom(options = {}) {
    return typeof options.now === 'function' ? Number(options.now()) : Date.now();
  }

  function read(options = {}) {
    try {
      const raw = storageFrom(options).getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return null;
      const ts = Number(data.ts || 0);
      if (!ts || (nowFrom(options) - ts) > TTL_MS) return null;
      return data;
    } catch (_) {
      return null;
    }
  }

  function snapshot(funnel = {}, options = {}) {
    return {
      v: 2,
      ts: nowFrom(options),
      step: String(funnel.step || '0'),
      occasion: funnel.occasion || null,
      occasionKey: funnel.occasionKey || null,
      occasionLabel: funnel.occasionLabel || null,
      sizeKey: funnel.sizeKey || null,
      budgetRange: funnel.budgetRange || null,
      paletteCanonical: Array.isArray(funnel.paletteCanonical) ? funnel.paletteCanonical : [],
      paletteColors: Array.isArray(funnel.paletteColors) ? funnel.paletteColors : [],
      paletteLabels: Array.isArray(funnel.paletteLabels) ? funnel.paletteLabels : [],
      variants: Array.isArray(funnel.variants) ? funnel.variants : [],
      activeProposalRequestId: funnel.activeProposalRequestId || null,
    };
  }

  function write(funnel = {}, options = {}) {
    try {
      const payload = snapshot(funnel, options);
      storageFrom(options).setItem(STORAGE_KEY, JSON.stringify(payload));
      return payload;
    } catch (_) {
      return null;
    }
  }

  function restoreInto(funnel, options = {}) {
    if (!funnel || typeof funnel !== 'object') return false;
    const saved = read(options);
    if (!saved) return false;

    funnel.step = String(saved.step || funnel.step || '0');
    funnel.occasion = saved.occasion || null;
    funnel.occasionKey = saved.occasionKey || saved.occasion || null;
    funnel.occasionLabel = saved.occasionLabel || null;
    funnel.sizeKey = saved.sizeKey || null;
    funnel.budgetRange = saved.budgetRange || null;
    funnel.paletteCanonical = Array.isArray(saved.paletteCanonical) ? saved.paletteCanonical : [];
    funnel.paletteColors = Array.isArray(saved.paletteColors) ? saved.paletteColors : funnel.paletteCanonical;
    funnel.paletteLabels = Array.isArray(saved.paletteLabels) ? saved.paletteLabels : [];
    funnel.variants = Array.isArray(saved.variants) ? saved.variants : [];
    funnel.activeProposalRequestId = saved.activeProposalRequestId || funnel.activeProposalRequestId || null;
    return true;
  }

  function clear(options = {}) {
    try {
      storageFrom(options).removeItem(STORAGE_KEY);
      return true;
    } catch (_) {
      return false;
    }
  }

  window.FlorameFunnelState = Object.freeze({
    key: STORAGE_KEY,
    ttlMs: TTL_MS,
    read,
    snapshot,
    write,
    restoreInto,
    clear,
  });
})();
